import React from "react";

// icons : feather
import FeatherIcon from "feather-icons-react";

export default function AppFormikInputFieldRadio(props) {
  const {
    id,
    formik,
    stFormClass,
    labelName,
    labelNameRight,
    isRequired,
    isDisabled = false,
    formikFieldName,
    isRound,
    value,
    onChange = () => { }
  } = props;

  return (
    <div
      className={`st-form ${stFormClass || ""} ${formik?.touched[formikFieldName] && formik?.errors[formikFieldName]
        ? "has-msg msg-error"
        : ""
        }`}
    >
      {labelName ? (
        <label>
          {labelName}
          {isRequired && <span className="required ms-1 st-fs-12">(required)</span>}
        </label>
      ) : null}
      <div
        className="media-body st-form-input-container"
        style={{ textAlign: "left" }}
      >
        <label
          className={`st-checkbox st-checkbox-primary d-inline-flex cursor-pointer position-relative ${isRound ? "rounded-circle" : ""
            }`}
          style={{ top: 2 }}
        >
          <input
            {...formik?.getFieldProps(formikFieldName)}
            type="checkbox"
            id={id}
            className="d-none"
            disabled={isDisabled}
            checked={value || ("" + formik?.values[formikFieldName] === "1")}
            onChange={(e) => {
              onChange(e)
              formik?.setFieldValue(
                formikFieldName,
                "" + formik?.values[formikFieldName] === "1" ? "0" : "1"
              );
            }}
          />
          <span className="box d-flex align-items-center justify-content-center border">
            <FeatherIcon
              icon="check"
              size="25"
              className="icon position-relative"
            />
          </span>
          {labelNameRight ? (
            <label style={{ marginLeft: "10px", fontWeight: "600" }}>
              {labelNameRight}
              {isRequired && <span className="required ms-1 st-fs-12">(required)</span>}
            </label>
          ) : null}
        </label>
        {
          /* form message */
          formik?.touched[formikFieldName] && formik?.errors[formikFieldName] && (
            <div
              className="st-form-msg position-absolute"
              style={{ bottom: -18 }}
            >
              <p className="st-fs-12">{formik?.errors[formikFieldName]}</p>
            </div>
          )
        }
      </div>
    </div>
  );
}
